import { SVGProps } from 'react';

export default function Location2(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2317_3294)">
        <path
          d="M10.0001 0.0351562C7.79507 0.0375822 5.68101 0.914552 4.12173 2.47368C2.56245 4.03281 1.68526 6.14678 1.68262 8.35182C1.68262 10.4935 3.34095 13.8452 6.61178 18.3135C7.00117 18.8469 7.511 19.2809 8.09979 19.5801C8.68857 19.8793 9.33968 20.0352 10.0001 20.0352C10.6606 20.0352 11.3117 19.8793 11.9004 19.5801C12.4892 19.2809 12.9991 18.8469 13.3885 18.3135C16.6593 13.8452 18.3176 10.4935 18.3176 8.35182C18.315 6.14678 17.4378 4.03281 15.8785 2.47368C14.3192 0.914552 12.2052 0.0375822 10.0001 0.0351562ZM10.0001 11.6668C9.34085 11.6668 8.69638 11.4713 8.14822 11.1051C7.60005 10.7388 7.17281 10.2182 6.92052 9.6091C6.66823 9.00002 6.60222 8.32979 6.73083 7.68319C6.85945 7.03659 7.17692 6.44264 7.64309 5.97647C8.10927 5.51029 8.70321 5.19282 9.34982 5.06421C9.99642 4.93559 10.6666 5.0016 11.2757 5.25389C11.8848 5.50618 12.4054 5.93343 12.7717 6.48159C13.138 7.02975 13.3335 7.67422 13.3335 8.33349C13.3335 9.21755 12.9823 10.0654 12.3571 10.6905C11.732 11.3156 10.8842 11.6668 10.0001 11.6668Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_3294">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
